import type {
  RequestLogListResponse,
  SignupListsResponse,
  UserListResponse,
} from "shell/console/types";

import { useSandboxAdminQuery } from "./useSandboxAdminApi";

export const useSandboxAdminUsers = () =>
  useSandboxAdminQuery<UserListResponse>(["sandboxAdmin", "users"], "/users");

export const useSandboxAdminSignupDomainLists = () =>
  useSandboxAdminQuery<SignupListsResponse>(
    ["sandboxAdmin", "signupDomainLists"],
    "/admin/signup-lists",
  );

export const useSandboxAdminRequestLogs = (userId?: string) =>
  useSandboxAdminQuery<RequestLogListResponse>(
    ["sandboxAdmin", "requestLogs", userId ?? "none"],
    "/clients/request-logs",
    {
      params: userId ? { user_id: userId } : undefined,
      enabled: Boolean(userId),
    },
  );
